import React from "react";
import { Breadcrumbs } from "web/react/components/breadcrumbs/breadcrumbs";
import { ExpandableText } from "web/react/emo/expandable-text/expandable-text";
import { Heading } from "web/react/emo/heading";
import { ImageContainer } from "web/react/emo/image-container";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";

import { useCuratedCollectionsAnalytics } from "web/react/hooks/use-curated-collection-analytics";
import { CuratedCollectionHeaderSerializer } from "web/types/serializers";
import * as styles from "./header.css";

interface HeaderProps extends CuratedCollectionHeaderSerializer {
    slug: string;
    sponsored: boolean;
}
export function Header({
    title,
    category,
    description,
    image,
    caption,
    slug,
    sponsored,
}: HeaderProps): React.ReactElement {
    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "Collections", url: null },
        { name: title, url: null },
    ];

    const { containerRef } = useCuratedCollectionsAnalytics({
        label: "header",
        curatedCollectionSlug: slug,
        isSponsored: sponsored,
        componentType: "intro_block",
    });

    return (
        <div className={styles.container} ref={containerRef}>
            <VStack spacing="md">
                <Breadcrumbs breadcrumbs={breadcrumbs} type="curated_collection" />
                <VStack spacing="xs">
                    {category && (
                        <Text
                            className={styles.category}
                            textStyle={{ sm: "caption-3-small", lg: "caption-3" }}
                            upperCase
                        >
                            {category}
                        </Text>
                    )}
                    <Heading textStyle={{ sm: "title-1", lg: "xl-large-title" }}>{title}</Heading>
                </VStack>
                {description && (
                    <div className={styles.text}>
                        <ExpandableText lineLimit={3} analyticsCategory={"curated_collections"}>
                            {description}
                        </ExpandableText>
                    </div>
                )}
            </VStack>
            {image && (
                <div className={styles.imageWrapper}>
                    <ImageContainer imageSrc={image} imageCredit={caption || ""} />
                </div>
            )}
        </div>
    );
}
